module.exports = __webpack_public_path__ + "img/play_3.6ba08a59.png";